import React from 'react'
import '../../../css/style.css'

const RequestSummaryTable = (props) => {

    return (
        <div>
          <table className="table request-summary-table cb-no-table-border">
            <thead>
              <tr className="tablerow table-header">
                  <th scope="col"><strong>Total Records</strong></th>
                  <th scope="col"><strong>Records Passed</strong></th>
                  <th scope="col"><strong>Records with Errors</strong></th>
              </tr>
            </thead>
            <tbody>
              <tr className="tablerow">
                <td> { props.dataItems.RECORDS_COUNT ? <strong>{props.dataItems.RECORDS_COUNT}</strong> : <strong>0</strong> } </td>
                <td className="successcountcolor"> { props.dataItems.SUCCESS_COUNT ? <strong>{props.dataItems.SUCCESS_COUNT}</strong> : <strong>0</strong> } </td>
                <td className="failcountcolor"> { props.dataItems.ERROR_COUNT ? <strong>{props.dataItems.ERROR_COUNT}</strong> : <strong>0</strong> } </td>
              </tr>
            </tbody>
          </table>
        </div>
    )
}

export default RequestSummaryTable
